import { useLang } from "../i18n/LanguageContext";
import { useFlow } from "../context/FlowContext";
import { Reveal } from "./motion";
import { ArrowRight } from "lucide-react";

export const MadridSection = () => {
  const { t } = useLang();
  return (
    <section className="relative py-16 md:py-20" data-testid="madrid">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="rounded-[2rem] border border-line bg-white p-8 md:p-12 text-center shadow-soft">
            <h3 className="font-heading text-2xl md:text-3xl font-medium text-ink">{t.madrid.title}</h3>
            <p className="mt-3 text-ink-soft leading-relaxed max-w-2xl mx-auto">{t.madrid.body}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export const CTAFinal = () => {
  const { t } = useLang();
  const { openClient } = useFlow();
  return (
    <section className="relative py-20 md:py-28" data-testid="cta-final">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="relative grain overflow-hidden rounded-[2.5rem] bg-forest text-white p-10 md:p-16 text-center shadow-[0_24px_50px_rgb(3,33,42,0.18)]">
            <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight leading-tight max-w-2xl mx-auto">{t.ctaFinal.title}</h2>
            <p className="mt-4 text-white/70 text-lg max-w-xl mx-auto">{t.ctaFinal.subtitle}</p>
            <button onClick={() => openClient()} className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white text-forest font-semibold px-8 py-4 hover:bg-sage-light transition-all duration-300 hover:-translate-y-1" data-testid="cta-final-help">
              {t.ctaFinal.cta}
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
